<template>
    <div class="home">
      <div class="home-head flex-b">
        <div @click="goTop">
          <img class="logo2-img" :src="'/static/logo/logo3-v'+Tversion+'.png'">
        </div>
        <div class="flex-content">
          <div class="home-login c-000 font-22" v-if="!token && Tversion==3">
            <router-link tag="div" to="/login" class="lang">{{$t('lg.lgs')}}</router-link>
          </div>
          <div><router-link tag="div" to="/language" class="lang">
            {{$t('index.language')}}
            <img src="@/assets/language.png" class="languageimg" />
          </router-link></div>
          <div @click="jumpPath('/user')">
            <img class="more-img" src="@/assets/temp1/me.png" alt="" v-if="TemplateType == 1">
            <img class="more-img" src="@/assets/new4/more.png" alt="" v-else>
          </div>
        </div>
      </div>
      <!-- <swiper ref="mySwiper"  :options="swiperOption" class="home-medical-box">
        <swiper-slide class="benefitBox" v-for="(item, index) in 3" :key="index" >
            {{item}}
        </swiper-slide>
      </swiper> -->
      <div class="home-box">
        <div class="home-email wow fadeInUp animated">
          <div class="flex-b p-b-15">
            <div class="" v-if="!token">
              <div class="c-000 font-44 p-b-52">{{$t('home.thedoor')}}</div>
              <div class="c-a8a8a8 font-34">{{$t('home.weare')}}</div>
            </div>
            <div v-else>
              <div class="c-000 font-34 p-b-23">{{$t('home.zzc')}}</div>
              <div class="c-000 font-58 p-b-23">{{money || 0}}</div>
              <div class="c-a8a8a8 font-34" style="width:80%">{{$t('home.gmjy')}}</div>
            </div>
            <div>
              <img class="gold-img" src="@/assets/new4/sucai.png" alt="">
            </div>
          </div>
          <div class="line1" v-if="token">
            <span class="butt text1 buttbg" @click="jumpSelectCurrency">{{$t('wydb.qcz')}}</span>
            <!-- <span class="butt text2" v-if="Tversion==3" @click="$router.push('/p2p')">{{$t('P2P交易')}}</span> -->
            <span class="butt text2" v-if="Tversion==3" @click="$router.push('/quicklyBuyCoins')">{{$t('快捷买币')}}</span>
          </div>
          <template v-if="Tversion!=1">
            <div class="c-000 font-34 p-t-30" v-if="!token">{{$t('home.emailaddress')}}</div>
            <div class="home-input" v-if="!token">
              <input type="text" v-model="value" :placeholder="$t('safe.paccount')" />
            </div>
          </template>
          <div class="btn-start font-40 c-fff buttbg" v-if="!token" @click="register">{{$t('home.start')}}</div>
        </div>

        <div class="notice2" v-show="noticeList.length > 0">
          <img src="@/assets/home_gonggao.png" class="img1" />
          <span class="textb" @click="$router.push('/notice2')">
            <span class="text1">
              <span style="margin-right: 15px;" v-if="noticeitem.id">{{noticeitem.title}}</span>
            </span>
          </span>
          <span class="text2" @click="$router.push('/notice2')">{{$t("更多")}}</span>
        </div>

        <div class="home-list w-100 wow fadeInUp animated">
          <div>
            <ul class="home-ul flex" v-if="TemplateType != 1">
              <!-- <li class="home-li" :class="{'active-li': type == 0}" @click="tab(0)" >{{$t('自选')}}</li> -->
              <li class="home-li" :class="{'active': type == 1}" @click="tab(1)">{{$t('langNew.szhb')}}</li>
              <li class="home-li" :class="{'active': type == 3}" @click="tab(3)">{{$t('langNew.yy')}}</li>
              <li class="home-li" :class="{'active': type == 2}" @click="tab(2)">{{$t('langNew.gjs')}}</li>
              <li class="home-li" :class="{'active': type == 10}" @click="tab(10)">{{$t('langNew3.xw')}}</li>
            </ul>
            <div class="menuL" v-else>
              <div class="list temp1color" :class="{'active': type == 1}" @click="tab(1)">
                <div>{{$t('langNew.szhb')}}</div>
                <div class="blueBottomLine" v-if="type == 1"></div>
              </div>
              <div class="list temp1color" :class="{'active': type == 3}" @click="tab(3)">
                <div>{{$t('langNew.yy')}}</div>
                <div class="blueBottomLine" v-if="type == 3"></div>
              </div>
              <div class="list temp1color" :class="{'active': type == 2}" @click="tab(2)">
                <div>{{$t('langNew.gjs')}}</div>
                <div class="blueBottomLine" v-if="type == 2"></div>
              </div>
              <div class="list temp1color" :class="{'active': type == 10}" @click="tab(10)">
                <div>{{$t('langNew3.xw')}}</div>
                <div class="blueBottomLine" v-if="type == 10"></div>
              </div>
            </div>
            <ul class="ul-body" v-show="type != 10">
              <li class="ul-tr" v-for="(item, index) in listData" :key="index" @click="jump(item)" v-if="index<8">
                <div class="flex-content">
                  <img class="ul-icon" v-if="item.type == 1" :src="item.icon" alt="">
                  <div class="font-34 c-000 p-tb-18">
                    {{item.name | rewriteName}}/USDT
                  </div>
                </div>
                <div class="flex-content">
                  <div style="text-align: right;">
                    <div class="font-34">
                      {{item.new_price || 0.00 | toFixed4}}
                    </div>
                    <div class="font-32" :class="[item.grow < 0 ?'c-cf4f4f':'c-009a62']">
                      <!-- <img class="ul-icon-arrow" v-if="item.grow < 0" src="@/assets/new4/arrow-down.png" alt="">
                      <img class="ul-icon-arrow" v-else src="@/assets/new4/arrow-up.png" alt=""> -->
                      {{item.grow || 0.000 | toFixed2}}%
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <vue-seamless-scroll :class-option="classOption" :data="list" v-show="type == 10" class="ul-wrap">
          <ul class="ul-box">
            <li class="li" v-for="(item,index) in list" :key="index" @click="jump2(item.id)">
              <div class="circle"></div>
              <div class="text c-000 font-35">{{item.time | timeGs}}</div>
              <div class="title c-000 font-4 ellipse">{{item.title}}</div>
              <div class="cont c-949494 font-35 ellipses3" v-html="item.content"></div>
            </li>
            <!-- <li class="li">
              <div class="circle"></div>
              <div class="text c-000 font-28">2024-09-07  22:14:12</div>
              <div class="title c-000 font-24 ellipses">以太坊突破2300美元,24小时跌幅收窄至0.8%</div>
              <div class="cont c-949494 font-24 ellipses2">最新消息,9月7日,据HTX行情信息,以太坊突破2300美元,现报价2303美元,24小时跌幅收窄至0.8%</div>
            </li> -->
          </ul>
        </vue-seamless-scroll>
        <!-- <div class="home-kline w-100 wow fadeInUp animated">
          <div class="font-44 c-000 p-t-80 p-b-52">{{$t('home.chart')}}</div>
          <div class="font-28 c-747474 p-b-60">{{$t('home.gold')}}</div>
          <home-kline></home-kline>
        </div> -->
        <div class="home-more w-100">
          <div class="font-44 c-000 p-t-80 p-b-52 wow fadeInUp animated">{{$t('home.more')}}</div>
          <div class="font-28 c-747474 wow fadeInUp animated">{{$t('我们为您提供了AI赚币、贷款、新币申购的功能')}}</div>
          <div class="more-list">
             <div class="more-li wow fadeInUp animated" data-wow-delay=".5s">
              <div>
                <div class="font-40 c-000 p-b-52">{{$t('langNew3.gdgnjxz')}}</div>
                <div class="font-32 c-747474">{{$t('langNew3.gdts')}}</div>
                <div class="more-btn buttbg" @click="jumpPath('/follow')">{{$t('langNew3.ksgd')}}</div>
              </div>
              <div class="p-b-52">
                <img class="w-160" src="@/assets/temp1/gendan.png" v-if="TemplateType == 1">
                <img class="w-160" src="@/assets/temp1/gendan.png" v-else>
              </div>
            </div>
            <div class="more-li wow fadeInUp animated" data-wow-delay=".5s">
              <div>
                <template v-if="Tversion == 3">
                  <div class="font-40 c-000 p-b-52">{{$t('home.ai_coin')}}</div>
                  <div class="font-32 c-747474">{{$t('home.ai_text')}}</div>
                </template>
                <template v-else>
                  <div class="font-40 c-000 p-b-52">{{$t('AI赚币计划进行中')}}</div>
                  <div class="font-32 c-747474">{{$t('开始AI赚币,稳定收益,高回报率,让您 躺着赚币')}}</div>
                </template>
                <div class="more-btn buttbg" @click="jumpPath('/propagate')">{{$t('home.get_start')}}</div>
              </div>
              <div class="p-b-52">
                <img class="w-160" src="@/assets/temp1/AI.png" v-if="TemplateType == 1">
                <img class="w-160" src="@/assets/new4/AI@2x.png" v-else>
              </div>
            </div>
            <div class="more-li wow fadeInUp animated" data-wow-delay=".5s">
              <div>
                <div class="font-40 c-000 p-b-52">{{$t('home.loan')}}</div>
                <div class="font-32 c-747474">{{$t('home.loan_text')}}</div>
                <div class="more-btn buttbg" @click="jumpPath('/currency')">{{$t('home.get_start')}}</div>
              </div>
              <div class="p-b-52">
                <img class="w-240" src="@/assets/temp1/daikuan.png" v-if="TemplateType == 1">
                <img class="w-240" src="@/assets/new4/daikuan@2x.png" v-else>
              </div>
            </div>
            <div class="more-li wow fadeInUp animated" data-wow-delay=".5s">
              <div>
                <template v-if="Tversion==3 || Tversion==5">
                  <div class="font-40 c-000 p-b-52">{{$t('私募币种')}}</div>
                  <div class="font-32 c-747474">{{$t('私募币种限量上线,您可以在这里买到您觉得有潜力的新币')}}</div>
                </template>
                <template v-else>
                  <div class="font-40 c-000 p-b-52">{{$t('home.newcurrency')}}</div>
                  <div class="font-32 c-747474">{{$t('home.alimited')}}</div>
                </template>
                <div class="more-btn buttbg" @click="jumpPath('/subscription')">{{$t('home.get_start')}}</div>
              </div>
              <div class="p-b-52">
                <img class="w-228" src="@/assets/temp1/NEWCoin.png" v-if="TemplateType == 1">
                <img class="w-228" src="@/assets/new4/xinbi@2x.png" v-else>
              </div>
            </div>
            <div class="more-li wow fadeInUp animated" data-wow-delay=".5s" v-if="Tversion==3">
              <div>
                <div class="font-40 c-000 p-b-52">{{$t('快捷买币')}}</div>
                <div class="font-32 c-747474">{{$t('更多币种，快捷买币')}}</div>
                <div class="more-btn" @click="jumpPath('/quicklyBuyCoins')">{{$t('去购买')}}</div>
              </div>
              <div class="p-b-52">
                <img class="w-240" src="@/assets/new4/kuaijie.png" alt="">
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="service" @click="service">
          <img class="service-icon" src="@/assets/new4/kefu2.png" alt="">
        </div> -->
      </div>

        <!-- 下载弹窗 -->
        <div class="download-box" v-show="isShow && !isPhone">
            <img class="logo" :src="logo" alt="">
            <div class="text-box">
                <p class="t1">{{this.project}}</p>
                <p class="t2">{{$t('download.t1')}}</p>
            </div>
            <a class="btn" @click="link">{{$t('download.xz')}}</a>
            <img class="btn-close" @click="downLoadClose" src="@/assets/close.png" alt="">
        </div>
        <!-- 公告弹窗 -->
        <div class="mask-notice" v-show="isNotice">
            <div class="notice-wrap">
                <div class="title">{{$t('news.gg')}}</div>
                <div class="cont" v-html="noticeHtml"></div>
                <div class="notice-btn btn-bg" @click="goDetail">{{$t('news.ckxq')}}</div>
                <img class="btn-close" @click="noticeClose" src="@/assets/Log-In_delete.png" alt="">
            </div>
        </div>
        <!-- 添加到主屏幕弹窗 -->
        <div class="alert-zpm-wrap" v-show="zpmShow && isPhone" @click="zpmClose">
            <div class="alert-zpm-box">
                <div class="zpm-head">
                    <div class="title">
                        <div class="t1">{{$t('indexNew.title')}}</div>
                        <img class="close" src="@/assets/close2.png" @click="zpmClose" alt="">
                    </div>
                    <div class="t2">{{$t('indexNew.t1')}}</div>
                </div>
                <div class="zpm-cont">
                    <img class="zpm-logo" src="@/assets/logo.png" alt="">
                    <div class="zpm-title">{{projectTitle}}</div>
                    <img class="img" src="@/assets/zpm/zpm-img01.jpg" alt="">
                    <ul class="item1-zpm-box">
                        <li class="text">{{$t('indexNew.t2')}}</li>
                        <li><img class="icon" src="@/assets/zpm/zpm-img02.png" alt=""></li>
                    </ul>
                    <ul class="item2-zpm-box">
                        <li class="text">{{$t('indexNew.t3')}}</li>
                        <li><img class="icon" src="@/assets/zpm/zpm-img03.png" alt=""></li>
                        <li class="text">""<span>{{$t('indexNew.t4')}}</span>""</li>
                    </ul>
                    <ul class="item3-zpm-box">
                        <li class="li-text t1">{{$t('indexNew.t6')}}</li>
                        <li class="li-text">{{$t('indexNew.t7')}}</li>
                        <li class="li-text t2">{{$t('indexNew.t4')}}</li>
                    </ul>
                    <div class="tips">{{$t('indexNew.t5')}}</div>
                    <div><img class="arrow-icon" src="@/assets/zpm/zpm-img05.png" alt=""></div>
                </div>
            </div>
        </div>
        <nav-bar :navName="'index'"></nav-bar>
        <!-- <loading v-show="isLoad"></loading> -->
        <div class="mask" v-if="needWallet">
          <div class="appDialog1">
            <div class="text1">Please download Trust Wallet</div>
            <div class="text2">This website operates based on Ethernet smart contracts,
              please use the Trust Wallet browser to access</div>
          </div>
        </div>
    </div>
</template>

<script>
import Web3Modal from 'web3modal';
import navBar from '@/components/NavBar.vue'
import loading from '@/components/loading.vue'
// import homeKline from '@/components/homeKline.vue'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import vueSeamlessScroll from 'vue-seamless-scroll'
let that = this;
let vm = null;
export default {
    name: 'index',
    components:{
        navBar,
        // homeKline,
        Swiper,
        SwiperSlide,
        vueSeamlessScroll,
        loading
    },
    data () {
      return {
        value:'',
        theme: false,
        logo: '',
        isShow: false,
        token: '',
        swiper: null,
        websock: null,
        bannerList: [],
        noticeList: [],
        noticeitem:{},
        noticeK:0,
        listData: [],
        currencyList: [],
        isNotice: false,
        noticeId: '',
        noticeHtml: '',
        isDownLoad: '',
        isNoticeShow: '',
        isLoad: false,
        service_link: '',
        swiperOption: {
          notNextTick: true,
          loop:true,
          pagination: {
              el: '.swiper-pagination',
              clickable :true,
          },
        },
        swiperOption2: {
            notNextTick: true,
            loop: true,
            direction: "vertical",
            autoplay:{
　　　　　　　　delay: 4000,    　　　　　　　　
　　　　　　     },
            on:{
                click: ()=>{
                    let swiper = this.$refs.mySwipers.$swiper;
                    let i = swiper.realIndex;
                    vm.goNotice(i);
                }
            },
        },
        lang: 'en',
        type: 1,
        zpmShow: false,
        isZpmShow: '',
        isPhone: false,
        money:'',
        needWallet:false,
        web3Modal:{},
        notice2:{},
        time1:null,
        reconnectWSNum:10,
        classOption: {
          limitMoveNum: 10,//开启无缝滚动的数据量
          direction: 1, //方向 0 往下 1 往上 2向左 3向右
          step: .5,//数值越大速度滚动越快
          hoverStop: true //启用鼠标hover控制
        },
        list:[],
        hasData: false,
        isLoad:false,
        address: '',
        isMn: false,
        isdemo: 2
      }
    },
    beforeCreate(){
        that = this;
    },
    created(){
        vm = this;
        this.theme = JSON.parse(localStorage.getItem('theme'));
        this.lang = localStorage.getItem('language') || 'en';
        this.token = localStorage.getItem('token') || '';
        this.money = localStorage.getItem('money');
        this.isdemo = localStorage.getItem('demoType') || 2;
        this.isMn = localStorage.getItem('isMn') || false;
        this.type = this.$route.query.type || 1;
        if(this.Tversion == 1 || this.Tversion == 5){
          setTimeout(()=>{
            this.checkwallet();
          },1000);
        }
        this.getNotice2();
        if(this.type == 10){
          this.getNews()
        }
    },
    mounted() {
      this.isDownLoad = sessionStorage.getItem('isDownLoad') || window.GLOBAL.isDownLoad;
		  this.isNoticeShow = sessionStorage.getItem('isNoticeShow');
      this.isZpmShow = sessionStorage.getItem('isZpmShow');
      this.isPhone = JSON.parse(sessionStorage.getItem('isPhone')) || false;
      this.$nextTick(() => {
        new this.$wow.WOW({resetAnimation: false,live: false }).init()
      })
      // window.addEventListener('scroll', this.$wow.WOW({resetAnimation: false,live: true }).init().sync(), true)
      if(this.isZpmShow){
        this.zpmShow = false;
      }else{
        this.zpmShow = true;
      }
      if(this.isDownLoad){
        this.isShow = false;
      }else{
        this.isShow = true;
      }
      // this.getTempLogin();
      this.getBanner();
      this.getGG();
      this.getmarketList();
      this.initWebSocket();
      this.getLogo();
      this.getParams();
      this.getAsset()
    },
    methods: {
      jump2(id){
        this.$router.push('/newsDetail?id=' + id)
      },
      getAsset(){
        this.$ajax.get('/web/getAsset2',{}).then((res) => {
              let resData = res.data.data;
              if(res.data.code == 1000){
                // this.$toast.center(res.data.message);
                // setTimeout(()=>{
                //   this.$router.push('/login');
                // },1000)
                return false
              }
              this.money = (Number(resData.totalMoney)).toFixed(4);
              localStorage.setItem('money',this.money);
          }).catch(function(err){
              console.log(err)
          })
      },
      goTop() {
        // window.scrollTo(0, 0);
        $('.home').animate({scrollTop:'0px'},'slow');
      },
      register() {
        if(this.Tversion == 1){
          this.$router.push('/login');
        }else{
          this.$router.push({ path: '/reg', query: { v: this.value } })
        }
      },
      jumpPath(path){
        this.$router.push({ path: path });
      },
       zpmClose(){
        if(this.isZpmShow != null){
          this.zpmShow = true;
          sessionStorage.removeItem('isZpmShow');
        }else{
          this.zpmShow = false;
          sessionStorage.setItem('isZpmShow',true);
        }
      },
      tab(id){
        this.type = id;
        // this.listData = [];
        this.currencyList = [];
        if(id != 10){
          this.getmarketList();
        }else{
          this.getNews();
        }
      },
      getNews(){
          let params = {
            page: 1,
            limit: 100
          }
          // this.isLoad = true
          this.$ajax.get('/web/getStocknews',{params}).then((res) => {
            this.isLoad = false
            let resData = res.data.data.data;
            if(resData.length > 0){
              this.list = this.list.concat(resData);
            }else{
              this.list = [];
            }
            if(this.list.length > 0){
                this.hasData = false;
            }else{
                this.hasData = true;
            }
          }).catch(function(err){
              console.log(err)
          })
      },
      service(){
        if(!this.service_link) return;
        this.$router.push({ path: '/service', query: { url: this.service_link } })
      },
      getParams(){
          this.$ajax.get('/web/getParam',{token: 1}).then((res) => {
              let resData = res.data.data;
              this.service_link = resData.filter((item) =>{
                  if(item.key == 'online_service'){
                      return item
                  }
              })[0].value;
          }).catch(function(err){
              console.log(err)
          })
       },

       // 滚动公告
       getNotice2(){
         this.$ajax.get('web/getTextsList',{type:'sign_rule'}).then((res) => {
            if(res.data && res.data.data && res.data.data.content){
              this.notice2 = res.data.data;
            }
         });
       },

        getTempLogin(){
		  	  let params = {
              token:1,
          }
          this.$ajax.get('/web/tempLogin',{params}).then((res) => {
              console.log(res)
          }).catch(function(err){
              console.log(err)
          })
        },
      goDetail(){
          this.$router.push({path: "/notice",query: { id: this.noticeId }});
      },
      goNotice(idx){
          let id = this.noticeList[idx].id;
          this.$router.push({path: "/notice",query: { id: id }});
      },
      bannerLink(i){
          let id = this.bannerList[i].id;
          let content = this.bannerList[i].content;
          if(id){
              if(this.filterHtmlTag(content)){
                  this.$router.push({path: "/bannerDetail",query: { id }});
              }
          }
      },
      noticeClose(){
        if(this.isNoticeShow != null){
        this.isNotice = true;
        sessionStorage.removeItem('isNoticeShow');
			}else{
				this.isNotice = false;
				sessionStorage.setItem('isNoticeShow',true);
			}
       },
       downLoadClose(){
           if(this.isDownLoad){
				this.isShow = true;
				sessionStorage.removeItem('isDownLoad');
			}else{
				this.isShow = false;
				sessionStorage.setItem('isDownLoad',true);
			}
       },
       link(){
           this.$router.push('/downLoad')
       },
       jumpSelectCurrency(url){
            this.$router.push({ path: '/selectCurrency', query: { type: 1,url: "deposit" } })
       },
       jump(item){
         localStorage.setItem("currentCoin",JSON.stringify(item));
         if(this.Tversion == 3){
           if(this.type == 1){
             this.$router.push({ path: '/contractTransaction', query: { symbol: item.symbol } })
           }else{
             this.$router.push({ path: '/contractTransaction2', query: { symbol: item.symbol } })
           }
         }else{
           this.$router.push({ path: '/contractTransaction', query: { symbol: item.symbol,bzType:item.type } })
         }
        },
       getBanner(){
		  	let params = {
                token:1,
            }
            this.$ajax.get('/web/getBanner',{params}).then((res) => {
                let resData = res.data.data;
                this.bannerList = resData;

            }).catch(function(err){
                console.log(err)
            })
        },
      getGG(id){
            this.$ajax.get('/web/getGG').then((res) => {
              if(res.data.code != 1000){
                var noticeArr = [];
                let resData = res.data.data;
                this.noticeList = resData;
                if(resData.length > 0){
                  this.time1 = setInterval(()=>{
                    if(this.noticeK<this.noticeList.length-1){
                      this.noticeitem = this.noticeList[this.noticeK];
                      this.noticeK ++;
                    }else{
                      this.noticeK = 0
                    }
                  },5000);
                  noticeArr = resData.filter((item,index) =>{
                  if(item.is_popover == 1){
                    return true;
                  }else{
                    return ''
                  }
                });
                if(noticeArr.length > 0){
                  if(this.isNoticeShow){
                    this.isNotice = false;
                  }else{
                    this.isNotice = true;
                  }
                  this.noticeId = noticeArr[0].id;
                  this.getNotice(this.noticeId);
                }
                }else{
                    this.isNotice = false
                }
              }else{
                this.isNotice = false
              }

          }).catch(function(err){
              console.log(err)
          })
		  },
      getNotice(id){
			  let params = {
              id:id,
            }
            this.$ajax.get('/web/getText',{params}).then((res) => {
                let resData = res.data.data;
                this.noticeHtml = this.contHtml(resData.content);
            }).catch(function(err){
                console.log(err)
            })
	  	},
      getLogo(){
			  let params = {
            key: 'app_logo',
            token:1,
        }
        this.$ajax.get('/web/getLogo',{params}).then((res) => {
          let resData = res.data.data;
          this.logo = resData;
        }).catch(function(err){
            console.log(err)
        })
	  	},
       getmarketList() {
        var that = this;
        let params = {
            type: this.type,
            token: '',
            id: 1,
            classify: 0
        }
        that.isLoad = true;
        this.$ajax.get('/web/getmarketList',{params}).then((res) => {
          let resData = res.data.data;
          var curr;
          that.listData = resData;
          that.currencyList = [];
          for (curr in that.listData){
            that.currencyList[that.listData[curr].currency] = [that.listData[curr].icon,that.listData[curr].symbol];
          }
          that.isLoad = false;
        }).catch(function(err){
            console.log(err)
        })
        },
       initWebSocket(){ //初始化weosocket
            const wsuri = this.socket_url;
            this.websock = new WebSocket(wsuri);
            this.websock.onmessage = this.websocketonmessage;
            this.websock.onopen = this.websocketonopen;
            this.websock.onerror = this.websocketonerror;
            this.websock.onclose = this.websocketclose;
        },
        websocketonopen(){ //连接建立之后执行send方法发送数据
        },
        websocketonerror(){//连接建立失败重连
          if(this.reconnectWSNum>0){
            setTimeout(()=>{
              this.initWebSocket();
            },10000);
            this.reconnectWSNum --;
          }
        },
        websocketonmessage(e){ //数据接收
          let msg = JSON.parse(e.data).content;
          if(JSON.parse(e.data).action == "marketprice"){
            let keyArr = [];
            for(var x in this.currencyList){
              for(var y in this.listData){
                x = this.type == 1 ? x.toLowerCase() : x;
                if(!msg[x]) return;
                if(msg[x].symbol == this.listData[y].symbol){
                  this.listData[y]['new_price'] = msg[x].now_price;
                  this.listData[y]['grow'] = msg[x].change;
                  keyArr.push(this.listData[y]);
                  break;
                }
              }
            }
            this.listData = keyArr;
          }
        },
        websocketsend(Data){//数据发送
            this.websock.send(Data);
        },
        websocketclose(e){  //关闭
            // console.log('断开连接',e);
        },
        contHtml(str){
            str = str.replace(/&amp;/g, '&');
            str = str.replace(/&lt;/g, '<');
            str = str.replace(/&gt;/g, '>');
            str = str.replace(/&quot;/g, "''");
            str = str.replace(/&#039;/g, "'");
            return str;
        },
        filterHtmlTag(msg){
            var msg = msg.replace(/<\/?[^>]*>/g, ''); //去除HTML Tag
                msg = msg.replace(/[|]*\n/, '') //去除行尾空格
                msg = msg.replace(/&nbsp;/ig, ''); //去掉nbsp
                return msg;
        },
        async checkwallet(){
          if (!window.ethereum) {
            // this.needWallet = true;
            // window.location.href = 'https://link.trustwallet.com';
          }else{
            if(!this.token){
              this.getAddress();
            }
          }
          // const provider = {};
          // this.web3Modal = new Web3Modal({
          //   network: this.domain,
          //   cacheProvider: true,
          //   providers: [
          //     {
          //       id: 'trust',
          //       name: 'Trust Wallet',
          //       type: 'walletconnect',
          //     },
          //     {
          //       id: 'defi',
          //       name: 'Defi Wallet',
          //       type: 'injected',
          //     },
          //   ],
          // });
          // if (!window.ethereum || !window.trustwallet.ethereum) {
          //   this.needWallet = true;
          //   // window.location.href = `https://link.trustwallet.com/open_url?url=${document.URL}`;
          //   window.location.href = `trust://open_url?url=${document.URL}`;
          //   // window.location.href = `defiwallet://open_url?url=${document.URL}`;
          // } else {
          //   provider.value = await this.web3Modal.connect('trust');
          //   provider.value = await this.web3Modal.connect('defi');
          //   const web3 = new Web3(provider.value);
          //   const accounts = await web3.eth.getAccounts();
          //   console.log('address:'+accounts[0]);
          // }
        },
      async getAddress() {
        var that = this;
        let web3Provider = null;
        if (window.ethereum) {
          web3Provider = window.ethereum;
          try {
            await window.ethereum.request({ method: "eth_requestAccounts" });
          } catch (error) {
            console.error("User denied account access");
            return false;
          }
        } else if (window.web3) {
          web3Provider = window.web3.currentProvider;
        } else {
          web3Provider = new Web3.providers.HttpProvider(that.adsHOST);
        }
        if (web3Provider) {
          const Web3address = new Web3(web3Provider);
          try {
            const accounts = await Web3address.eth.getAccounts();
            const address = accounts[0];
            if (address) {
              that.address = address;
              that.getEthLogin();
            } else {
              that.$toast.center('Failed to connect to address');
            }
          } catch (error) {
            that.$toast.center('Failed to connect to address');
          }
        } else {
          that.$toast.center('Failed to connect to address');
        }
      },
      getEthLogin(){
        let params = {
            address: this.address,
            // address: '0xCA62b5Cb65D4dad8AeEea158cB72a4257Fc25E24'
        }
        this.$ajax.get('/web/ethLogin',{params}).then((res) => {
          let resData = res.data.data;
          if(res.data.code == 0){
            this.saveData(resData);
          //  this.$router.push('/index');
          }else{
            this.$toast.center(res.data.message);
          }
        }).catch(function(err){
            console.log(err)
        })
      },
      saveData(res){
        localStorage.setItem('token',res.token);
        localStorage.setItem('uid',res.id);
        localStorage.setItem('agentId',res.agent_id);
        localStorage.setItem('invitation_code',res.invitation_code);
        localStorage.setItem('link',res.link);
        localStorage.setItem('userName',res.name);
      },

    },

    beforeDestroy() {
      // this.websock.close(); //离开路由之后断开websocket连接
      if(this.time1){
        clearInterval(this.time1);
      }
    },
    // destroyed() {
    //   this.websock.close() //离开路由之后断开websocket连接
    // }
}
</script>
<style scoped>
  .appDialog1{background-color: #fff;width: 300px;margin: 20% auto;border-radius: 10px;padding: 20px;}
  .appDialog1 .text1{text-align: center;font-size: 18px;margin-bottom: 10px;}
  .appDialog1 .text2{font-size: 14px;}
  .notice2{display: flex;justify-content: space-between;align-items: center;margin: 15px 0;}
  .notice2 .img1{width: 25px;}
  .notice2 .textb{margin: 0 10px;text-align: left;width: 75%;position: relative;overflow: hidden;}
  .notice2 .textb .text1{position: relative;animation: noticeItemAc 10s;animation-timing-function:linear;
    animation-iteration-count:infinite;width: 150%;display: inline-block;}
  .notice2 .text2{font-weight: bold;font-size: 0.45rem;}
  @keyframes noticeItemAc
  {
      from {left: 100%;}
      to {left: -150%;}
  }

  .logo2-img{
    width: 3.1rem;
    height: 0.8rem;
  }
  .languageimg{width: 20px;vertical-align: middle;margin-left: 5px;}
  .more-img{
    width: .7rem;
    height: .7rem;
    margin-left: .5rem;
  }
  .service{
    position: fixed;
    right: .2rem;
    bottom: 2.5rem;
  }
  .service-icon{
    width: 1.3rem;
    height: 1.3rem;
  }
  .font-22{
    font-size: .32rem;
  }
  .font-28{
    font-size: .4rem;
  }
  .font-32{
    font-size: .45rem;
  }
  .font-34{
    font-size: .5rem;
  }
  .font-40{
    font-size: .57rem;
  }
  .font-44{
    font-size: .63rem;
  }
  .font-58{
    font-size: .83rem;
  }
  .c-000{
    color: #000;
  }
  .c-fff{
    color: #fff;
  }
  .c-747474{
    color: #747474;
  }
  .c-a8a8a8{
    color: #a8a8a8;
  }
  .c-9a9a9a{
    color: #9a9a9a;
  }
  .c-cf4f4f{
    color: #cf4f4f;
  }
  .c-009a62{
    color: #009a62
  }
  .p-l-20{
    padding-left: .3rem;
  }
  .p-tb-18{
    padding: .26rem 0;
  }
  .p-b-23{
    padding-bottom: .32rem;
  }
  .p-b-52{
    padding-bottom: .73rem;
  }
  .p-b-60{
    padding-bottom: .86rem;
  }
  .p-t-30{
    padding-top: .3rem;
  }
  .p-t-80{
    padding-top: 1.4rem;
  }
  .p-r-92{
    padding-right: 1.3rem;
  }
  .m-t-64{
    margin-top: .9rem;
  }
  .w-60{
    width: .85rem;
  }
  .w-100{
    width: 100%;
  }
  .w-160{
    width: 2.3rem;
  }
  .w-240{
    width: 3.43rem;
  }
  .w-228{
    width: 3.23rem;
  }
  .w-177{
    width: 2.55rem;
  }
  .w-185{
    width: 2.66rem;
  }
  .w-169{
    width: 2.43rem;
  }
  .home{
    position: relative;
  }
  .home-box{
    padding: 0 .57rem 2.8rem;
  }
  .home-head{
    position: sticky;
    top: 0;
    z-index: 8;
    padding: .5rem;
    background: #fff;
  }
  .home-login{
    padding: 5px 10px;
    text-align: center;
    background-color: #fff;
    border-radius: .14rem;
    margin-right: .5rem;
  }
  /* .home-list{
    background-color: #1c1c21;
  } */
  .ul-body{
    display: flex;
    flex-direction: column;
    /* flex-wrap: wrap;
    justify-content: space-between; */
    box-shadow: 0 0 8px 3px #00000020;
    border-radius: .5rem;
    position: relative;
    top: -0.4rem;
  }
  .ul-tr{
    /* min-width: 38%; */
    border-radius: .45rem;
    padding: .45rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .ul-icon{
    width: .9rem;
    height: .9rem;
    padding-right: .3rem;
  }
  .ul-icon-arrow{
    width: .57rem;
    height: .57rem;
  }
  .home-ul{
  }
  .home-li{
    padding: 3px 15px;
    height: 1rem;
    line-height: 1rem;
    text-align: center;
    font-size: .5rem;
    color: #7d7d7d;
    background-image: linear-gradient(183deg,
    		#e0e0e0 0%,
    		#ffffff 100%),
    	linear-gradient(
    		#666666,
    		#666666);
    	background-blend-mode: normal,
    		normal;
    	border-radius: .3rem .3rem 0 0;
  }
  .active{
    color: #000;
    font-size: .55rem;
    font-weight: bold;
    border-radius: .15rem .15rem 0 0;
    padding-bottom: 0.5rem;
    position: relative;
    top: -0.2rem;
  }
  .more-li{
    border-radius: .43rem;
    padding: .74rem .9rem;
    box-shadow: 0 0 0.38rem 0.19rem rgba(6, 0, 1, 0.15);
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.5rem;
  }
  .more-btn{
    width: 2.7rem;
    height: 1rem;
    background-color: #000;
    border-radius: .5rem;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: .8rem;
  }
  .home-email{padding-top: 1rem;}
  .home-email .line1{margin-top: 0.3rem;display: flex;padding-bottom: 0.3rem;}
  .home-email .line1 .butt{padding: 0.3rem 0.7rem;font-size: 0.5rem;color: #fff;margin-right: 0.3rem;
    border-radius: 100px;}
  .home-email .line1 .text1{background-color: #000;}
  .home-email .line1 .text2{border: 1px solid #666;color: #000;}
  .home-input{
    width: 100%;
    margin: .66rem 0 .35rem 0;
  }
  .home-input input{
    width: calc(100% - 0.8rem);
    border-radius: .15rem;
    font-size: 0.5rem;
    border:1px solid #999;
    padding: 0.4rem;
    outline: none;
  }
  .home-input input:focus{border: 1px solid #4458ed;}
  .home-all {
    width: 3rem;
    height: .9rem;
    line-height: .9rem;
    text-align: center;
    background-color: #212228;
    border-radius: .15rem;
    margin: .5rem 0 .95rem;
  }
  .gold-img{
    width: 2.8rem;
    height: 2.6rem;
  }
  .btn-start{
    width: 9.7rem;
    height: 1.5rem;
    line-height: 1.5rem;
    text-align: center;
    background-color: #000;
    border-radius: .75rem;
  }

    .head{
        position: fixed;
        top: 0;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        background: #fff;
        box-sizing: border-box;
    }
    .head .icon{
        width: .9rem;
        height: .94rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .head .lang{
        position: absolute;
        top: 50%;
        right: .4rem;
        font-size: .42rem;
        transform: translateY(-50%);
    }
    .cotainer{
        position: absolute;
        top: 1.6rem;
        bottom: 2.1rem;
        width: 100%;
        background: #fff;
        overflow-y: scroll;
    }
    .cotainer .banner-wrap{
      height: 3.92rem;
      margin: 0 .44rem;
    }
    .cotainer .banner-wrap .banner-box{
      height: 100%;
    }
    .cotainer .banner-box .img{
        width: 100%;
        height: 3.92rem;
        border-radius: .2rem;
    }
    .cotainer .notice-box{
        display: flex;
        align-items: center;
        height: 1rem;
        padding: 0 .44rem;
        overflow: hidden;
    }
    .cotainer .notice-box .icon{
        width: .6rem;
    }
    .cotainer .notice-box .notice{
        flex: 1;
        height: 1rem;
        padding: 0 .4rem;
        line-height: 1rem;
        overflow: hidden;
    }
    .cotainer .notice-box .notice .swiper-container{
        height: 1rem;
    }
    .cotainer .notice-box .notice .text{
        color: #000;
        font-size: .4rem;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
    .cotainer .notice-box .arrow{
      width: .3rem;
    }
    .cotainer .coin-box{
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        margin: .3rem .32rem 0;
        overflow-x: scroll;
    }
    .cotainer .coin-box .coin-li{
        padding: .2rem .3rem .16rem;
        text-align: center;
    }
    .cotainer .coin-box .coin-head{
        display: flex;
        align-items: center;
    }
    .cotainer .coin-box .coin-head .icon{
        width: .59rem;
        height: .59rem;
    }
    .cotainer .coin-box .coin-head .text{
        color: #000;
        font-size: .35rem;
        padding-left: .2rem;
    }
    .cotainer .coin-box .coin-head .text .t1{
        color: #b0b0b0;
    }
    .cotainer .coin-box .price{
        padding: .3rem 0 .2rem;
        color: #000;
        font-size: .48rem;
    }
    .cotainer .coin-box .change{
        display: flex;
        justify-content: center;
        align-items: center;
        color: #49d674;
    }
    .cotainer .coin-box .change .arrow{
        height: .8rem;
        margin-right: .1rem;
    }
     .cotainer .coin-box .change .arrow.die{
         transform: rotate(180deg);
     }
    .cotainer .line{
        width: 100%;
        height: .18rem;
        background: #f9f9f9;
    }
    .cotainer .item-box{
        display: flex;
        justify-content: flex-start;
        align-items: stretch;
        flex-flow: wrap;
    }
    .cotainer .item-box .item{
        width: 25%;
        padding: .4rem 0;
        text-align: center;
    }
    .cotainer .item-box .item .icon{
        /* width: .72rem; */
        height: .8rem;
    }
    .cotainer .item-box .item .text{
        padding-top: .3rem;
        color: #000;
        font-size: .34rem;
    }
    .cotainer .table-head{
        display: flex;
        align-items: center;
        padding: .4rem .32rem 0;
    }
    .cotainer .table-head .th{
        width: 33.33%;
        color: #7f7f7f;
        font-size: .35rem;
    }
    .cotainer .table-body{
        padding: 0 .4rem;
    }
    .cotainer .table-body .tr{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .4rem 0;
        border-bottom: 1px solid #eee;
    }
    .cotainer .table-body .tr .item{
        width: 33.33%;
    }
    .cotainer .table-body .coin{
        display: flex;
        align-items: center;
    }
    .cotainer .table-body .coin .icon{
        width: .94rem;
        height: .94rem;
        margin-right: .3rem;
    }
    .cotainer .table-body .coin .t1{
        color: #000;
        font-size: .38rem;
    }
    .cotainer .table-body .coin .t2{
        color: #b0b0b0;
        font-size: .32rem;
    }
    .cotainer .table-body .price{
        color: #000;
        font-size: .48rem;
    }
    .cotainer .table-body .change .persent{
        display: inline-block;
        width: 2rem;
        padding: 6px;
        color: #fff;
        border-radius: 4px;
        background: #00c483;
        text-align: center;
    }
    /* 公告弹窗 */
    .notice-wrap{
        position: fixed;
        left: 5%;
        right: 5%;
        top: 50%;
        z-index: 12;
        width: 90%;
        padding: 0 6px;
        border-radius: 4px;
        background: #fff;
        box-sizing: border-box;
        transform: translateY(-50%);
    }
    .notice-wrap .title{
        padding: 10px;
        color: #000;
        font-size: 15px;
        text-align: center;
    }
    .notice-wrap .cont{
        min-height: 80px;
        max-height: 200px;
        padding: 10px;
        color: #666;
        font-size: 12px;
        word-break: break-word;
        overflow-y: auto;
    }
    .notice-wrap .notice-btn{
        height: 36px;
        margin: 10px 10px 20px;
        line-height: 36px
    }
    .notice-wrap .btn-close{
        position: absolute;
        right: 10px;
        top: 10px;
        width: 20px;
    }
    /* 下载框 */
    .download-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: fixed;
        left: 2%;
        bottom:2.1rem;
        width: 96%;
        height: 60px;
        padding: 0 5px;
        border-radius: 4px;
        background: #3381d5;
        box-sizing: border-box;
    }
    .download-box .logo{
        height: 25px;
    }
    .download-box .text-box .t1{
        font-size: 13px;
        margin-bottom: 4px;
    }
    .download-box .text-box{
        flex: 1;
        margin: 0 5px;
        color: #fff;
        font-size: 12px;
    }
    .download-box .btn{
        margin-right: 15px;
        padding: 5px 10px;
        color: #000;
        font-size: 12px;
        border-radius: 4px;
        background: #fff;
        text-align: center;
    }
    .download-box .btn-close{
        position: absolute;
        right: 3px;
        top: 3px;
        z-index: 999;
        width: 12px;
        height: 12px;
    }
    .tab-box{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: .42rem 0;
    }
    .tab-box .tab{
      position: relative;
      padding: 0 .5rem;
      color: #150700;
      font-size: .52rem;
    }
    .tab-box .tab.active::after{
      position: absolute;
      left: 50%;
      bottom: -.2rem;
      content: '';
      width: .78rem;
      height: .06rem;
      background: #2d66cf;
	    border-radius: 0.03rem;
      transform: translateX(-50%);
    }
    .alert-zpm-wrap{
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.6);
  }
  .alert-zpm-wrap .alert-zpm-box{
    position: absolute;
    bottom: 0;
    z-index: 100;
    width: 100%;
    border-radius: 6px 6px 0 0;
    background: #fff;
    overflow-y: scroll;
  }
  .alert-zpm-wrap .zpm-head{
    padding: 12px 18px 0;
  }
  .alert-zpm-wrap .zpm-head .title{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .alert-zpm-wrap .zpm-head .t1{
    flex: 1;
    color: #000;
    font-size: 15px;
  }
  .alert-zpm-wrap .zpm-head .close{
    width: 18px;
  }
  .alert-zpm-wrap .zpm-head .t2{
    padding: 10px 0;
    color: #a1a1a1;
    font-size: 12px;
  }
  .alert-zpm-wrap .zpm-cont{
    position: relative;
    padding: 0 5px;
    color: #000;
    font-size: 14px;
    text-align: center;
  }
   .alert-zpm-wrap .zpm-cont .zpm-logo{
     position: absolute;
     left: 50%;
     top: 0;
     width: 50px;
     height: 50px;
     transform: translateX(-50%);
   }
   .alert-zpm-wrap .zpm-cont .zpm-title{
     position: absolute;
     top: 55px;
     left: 0;
     right: 0;
     color: #000;
     font-size: 14px;
   }
  .alert-zpm-wrap .zpm-cont .img{
    width: 150px;
    margin: auto;
  }
  .alert-zpm-wrap .zpm-cont .item1-zpm-box{
    display: flex;
    justify-content: center;
    align-items: center;
    /* padding: 10px 0; */
  }
  .alert-zpm-wrap .zpm-cont .item1-zpm-box .icon{
    width: 40px;
  }
  .alert-zpm-wrap .zpm-cont .item2-zpm-box{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .alert-zpm-wrap .zpm-cont .item2-zpm-box .text{
    font-size: 14px;
  }
  .alert-zpm-wrap .zpm-cont .item2-zpm-box .icon{
    width: 40px;
    margin: 0 8px;
  }
  .alert-zpm-wrap .zpm-cont .item3-zpm-box{
    width: 280px;
    height: 120px;
    margin: auto;
    background: url('../assets/zpm/zpm-img04.png') no-repeat center center;
    background-size: cover;
  }
  .alert-zpm-wrap .zpm-cont .li-text{
    height: 34px;
    padding: 0 30px;
    color: #000;
    line-height: 34px;
    font-size: 12px;
    text-align: left;
  }
  .alert-zpm-wrap .zpm-cont .li-text.t1{
    padding-top: 4px;
  }
  .alert-zpm-wrap .zpm-cont .li-text.t2{
    font-size: 13px;
    font-weight: bold;
  }
  .alert-zpm-wrap .zpm-cont .tips{
    padding: 0 0 10px;
    font-size: 12px;
  }
  .alert-zpm-wrap .zpm-cont .arrow-icon{
    width: 40px;
    margin-bottom: 10px;
  }
/* 新闻 */
 .home .ul-wrap{
      position: relative;
      height: 12rem;
      padding: .6rem .2rem .45rem .12rem;
      background: #fff;
      box-shadow: 0rem 0.16rem 0.73rem 0rem
        rgba(0, 0, 0, 0.17);
      border-radius: 0.3rem;
      overflow-y: hidden;
    }
    .home .ul-box{
      position: relative;
      margin: 0 0 0 .2rem;
      /* padding-right: .2rem; */
      border-left: 1px solid #b1b1b1;
    }
    .home .ul-box .li{
      position: relative;
      z-index: 6;
      margin: 0 0 .6rem .15rem;
      padding: 0 .3rem;
    }
    .home .ul-box .li .circle{
      position: absolute;
      left: -.25rem;
      top: 0;
      z-index: 5;
      width: 0.14rem;
      height: 0.14rem;
      background: #000;
      border: solid 0.01rem #00994e;
      border-radius: 50%;
    }
    .home .ul-box .li .text{
      font-weight: bold;
    }
    .home .ul-box .li .title{
      padding: .32rem 0;
      font-weight: bold;
    }
    .home .ul-box .li .cont{
      max-height: 1rem;
      height: 1rem;
      overflow: hidden!important;;
    }

</style>

<style type="text/css" lang="less" scoped>
.menuL{display: flex;
  .list{padding: 0.2rem 0.6rem 0.4rem 0;top: 0;text-align: center;font-size: 0.45rem;
    .blueBottomLine{top: -0.2rem;}
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/index.vue